export const Sky = () => <div className="fixed inset-0 -z-10 city-bg pointer-events-none" data-testid="sky-background" />;
